import React, {Component} from "react"
import BillingHistoryRecord from "./BillingHistoryRecord";
import * as PropTypes from "prop-types";

class BillingHistory extends Component {
    render() {
        const {billingHistory, billingError} = this.props

        if (!!billingError) {
            return (
                <div className="BillingHistoryError">{billingError}</div>
            )
        }

        return (
            <div className="BillingHistory">
                <table>
                    <thead>
                    <tr>
                        <th>Date</th>
                        <th>Description</th>
                        <th>Method</th>
                        <th>Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        billingHistory.map((bill, index) => {
                            return (
                                <BillingHistoryRecord key={'billing-record'+ bill._id} index={index} bill={bill} />
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
        )
    }
}

BillingHistory.propTypes = {
    billingHistory: PropTypes.array.isRequired,
    billingError: PropTypes.string
}

export default BillingHistory



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/user/UserPage/components/BillingHistory.js